import { keepPreviousData, useQuery } from '@tanstack/react-query';

import {
  partnersOffersApi,
  partnersOffersApiKeys,
  type PartnerOffersListParams,
} from '@/api/routes/partners/partners.offers.api';

/** One page of the partner's offers. Keeps the page on screen while another tab loads. */
export const usePartnersReadOffers = (params: PartnerOffersListParams) => {
  return useQuery({
    queryKey: partnersOffersApiKeys.list(params),
    queryFn: () => partnersOffersApi.list(params).then((res) => res.data),
    placeholderData: keepPreviousData,
  });
};
